import { _common } from "./common";
import { ServerInterface } from "./ServerInterface";
const common = _common;

export class Functions {
  static createDeleteInfo(): any {
    return {
      user: common.user,
      dateCreated: new Date(),
    }
  }

  static book(bookingInfo: any): Promise<boolean> {
    return new Promise((resolve) => {
      ServerInterface.book(bookingInfo).then((msg) => {
        if (msg) {
          common.myAlert(msg, "Platzbuchung konnte nicht durchgeführt werden", () => resolve(false));
        } else {
          if (common.clubhausMode) {
            resolve(true);
          } else {
            common.myAlert("Wir freuen uns, Dich bald auf dem Kreuzberg zu begrüßen", "Platzbuchung ist erfolgt", () => resolve(true));
          }
        }
      });
    });
  }

  static uuidv4(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  static bookSerie(bookingInfo: any): Promise<boolean> {
    return new Promise((resolve) => {
      bookingInfo.uidSerie = Functions.uuidv4();

      ServerInterface.book(bookingInfo).then((msg) => {
        if (msg) {
          common.myAlert(msg, "Platzbuchung konnte nicht durchgeführt werden", () => resolve(false));
        } else {
          common.myAlert("_", "Serienbuchungbuchung ist erfolgt", () => resolve(true));
        }
      });
    });
  }

  static async deleteBooking(bookingInfo: any) {
    return new Promise<void>((resolve) => {
      common.myConfirm("Willst Du die Buchung wirklich löschen", () => {
        bookingInfo.deleteInfo = Functions.createDeleteInfo()
        ServerInterface.deleteBooking(bookingInfo);
        resolve();
      });
    });
  }

  static async deleteBookingSerie(bookingInfo: any) {
    return new Promise<void>((resolve) => {
      common.myConfirm("Willst Du die Buchungsserie wirklich löschen", () => {
        ServerInterface.deleteBookingSerie(bookingInfo);
        resolve();
      });
    });
  }
}
